declare const I18n;

import React from "react";
import "@/components/Chart/chart"; // ChartJS.register(...)
import { Pie } from "react-chartjs-2";

export type LearnersExperienceItem = {
  label: string;
  value: number; // raw value
  color?: string;
};

type LearnersExperienceLevelChartProps = {
  items: LearnersExperienceItem[];
  height?: number; // px
};

const DEFAULT_COLORS = ["#8DC863", "#E60B80", "#42C0C6", "#CAB2E0"];

const LearnersExperienceLevelChart: React.FC<
  LearnersExperienceLevelChartProps
> = ({ items, height = 550 }) => {
  const total = items.reduce((sum, i) => sum + i.value, 0);

  const itemsWithPercent = items.map((i) => ({
    ...i,
    percent: total > 0 ? Math.round((i.value / total) * 100) : 0,
  }));

  const data = {
    labels: itemsWithPercent.map((i) => i.label),
    datasets: [
      {
        data: itemsWithPercent.map((i) => i.value), 
        backgroundColor: itemsWithPercent.map(
          (i, idx) => i.color || DEFAULT_COLORS[idx % DEFAULT_COLORS.length]
        ),
        borderWidth: 0,
        radius: "70%",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          color: "#ffffff",
          font: { size: 16, weight: "400" },
          boxWidth: 12,
          boxHeight: 12,
          padding: 48,
        },
      },

      tooltip: {
        enabled: true,
        displayColors: true,
        callbacks: {
          title: () => "",
          label: (context) => {
            const item = itemsWithPercent[context.dataIndex];
            if (!item) return "";
            return `${item.label}: ${item.value} (${item.percent}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="learners-experience-level-chart-container">
      <h2 style={{ marginBottom: "2.5rem" }}>
        {I18n.t("views.learners.index.charts.your_learners_experience_levels")}
      </h2>
      <div style={{ height }}>
        <Pie data={data} options={options} />
      </div>
    </div>
  );
};

export default LearnersExperienceLevelChart;
